import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

type Item = { [key: string]: any };

@Pipe({
  name: 'filterListByString',
  standalone: true
})
export class FilterListByStringPipe implements PipeTransform {

  transform(list: Item[], searchValue: string, isDriverMode: boolean): Item[] {
    const searchValueLower = searchValue.toLowerCase();

    const getNameValue = (item: Item): string => {
      if (isDriverMode) {
        return `${get(item, 'Driver.FN', '')} ${get(item, 'Driver.LN', '')}`;
      }
      return get(item, 'Vehicle.Nm', '');
    };

    return list.filter(item => getNameValue(item).toLowerCase().includes(searchValueLower));
  }

}
